import React, { useCallback } from 'react';
import styled from 'styled-components';
import media from 'styled-media-query';
import SelectBox from 'src/components/atoms/form/SelectBox';
import SingleInputFormBlock from 'src/components/molecules/form/SingleInputFormBlock';

interface Props {
  query: string;
  listType: string;
  listTypeOptions: { value: string; content: string }[];
  bakedBreadTag: string;
  bakedBreadTagOptions: { value: string; content: string }[];
  onChangeQuery: (text: string) => void;
  onChangeBakedBreadTag: (id: string) => void;
  onChangeListType: (listType: 'detail' | 'list') => void;
}

const BakedBreadFilterForm = ({ ...props }: Props) => {
  const {
    query,
    listType,
    listTypeOptions,
    bakedBreadTag,
    bakedBreadTagOptions,
    onChangeQuery,
    onChangeBakedBreadTag,
    onChangeListType,
  } = props;

  const wrapOnChangeListType = useCallback((value: string) => {
    if (value === 'list' || value === 'detail') {
      onChangeListType(value);
    }
  }, [onChangeListType]);

  return (
    <Filter>
      <div className="first">
        <SingleInputFormBlock
          isRequired={false}
          labelName=""
          inputType="text"
          inputValue={query}
          placeholder="パンの名前で絞り込む"
          onChange={(v) => onChangeQuery(v)}
          isError={false}
          isDisabeld={false}
        />
      </div>
      <div className="second">
        <SelectBox
          id="bakedBreadTag"
          placeholder="カテゴリで絞り込む"
          inputValue={bakedBreadTag}
          onChange={onChangeBakedBreadTag}
          options={bakedBreadTagOptions}
        />
      </div>
      <div className="third">
        <SelectBox
          id="listType"
          placeholder=""
          inputValue={listType}
          onChange={wrapOnChangeListType}
          options={listTypeOptions}
        />
      </div>
    </Filter>
  );
};

const Filter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 16px;
  ${media.lessThan('medium')`
    flex-wrap: wrap;
  `};

  .first,
  .second {
    ${media.greaterThan('medium')`
      flex-grow: 2;
      padding-right: 24px;
    `};
    ${media.lessThan('medium')`
      width: 100%;
      padding: 0 24px;
    `};
  }

  .second {
    ${media.lessThan('medium')`
      padding-top: 12px;
    `};
  }

  .third {
    select {
      padding-right: 34px;
    }
    ${media.lessThan('medium')`
      padding: 12px 24px 0 0;
      margin-left: auto;
    `};
  }
`;

export default BakedBreadFilterForm;
